import React, { useEffect, useState } from "react";
import { Button, Col, Row, Typography } from "antd";
import PastaIcon from "../../../../../static/PastaIcon";
import Megaphone from "../../../../../static/Megaphone";
import { useSelector } from "react-redux";
import { CloseCircleOutlined } from "@ant-design/icons";
import { useHistory } from "react-router";
import moment from 'moment';

const { Title, Paragraph } = Typography;

function Newsletter(props) {
  const history = useHistory();
  const [showPopUp, setShowPopUp] = useState(false); 
  const verticalId = useSelector(state => state.companyConfig.vertical_id);

  const Icon = () => verticalId === 3 ? <PastaIcon /> : <Megaphone />;

  useEffect(() => {
    const isDismissed = window.localStorage.getItem('_dn');
    if (!isDismissed) {
      setShowPopUp(true);
    }
  }, [])


  const goToForm = () => {
    history.push(`/public/welcome/form/newsletter-form`);
  };

  const dismiss = (e) => {
    e.stopPropagation();
    window.localStorage.setItem('_dn', (moment.utc()).valueOf());
    setShowPopUp(false);
  }

  if (showPopUp) {
    return (
      <Row>
        <Col xs={0} md={8}></Col>
        <Col xs={24} md={8}>
          <div className="newsletter-wrapper">
            <div className="newsletter-body" onClick={goToForm}>
              <div className="newsetter-icon-wrapper">
                <div className="newsetter-icon">
                  <Icon />
                </div>
              </div>
              <div className="newsletter-title">
                <Title level={4} strong>
                  {"Angebote & Aktionen"}
                </Title>
              </div>
              <Button type="text" className="dismiss-button" onClick={dismiss}>
                <CloseCircleOutlined />
              </Button>
              <Paragraph className="newsletter-text">
              Klicken Sie hier, um sich für unseren Newsletter anzumelden und über unsere neuesten Aktionen und Angebote auf dem Laufenden zu bleiben.
              </Paragraph>
            </div>
          </div>
        </Col>
        <Col xs={0} md={8}></Col>
      </Row>
    );
  } else {
    return null;
  }
}

export default Newsletter;
